module.exports = __webpack_public_path__ + "static/media/bg-login-cms-min.11d80ba8.jpg";